module.exports = __webpack_public_path__ + "static/media/icon-activite.3d0cf6fe.svg";